// extracted by mini-css-extract-plugin
export default {"innerBox":"ImportExcelFile_innerBox__JZNGP"};